module.exports = __webpack_public_path__ + "img/folder.4fdafa7d.svg";